<template>
  <v-card class="pb-12" color="transparent" flat>
    <v-list-item>
      <v-list-item-avatar tile>
        <SvgIcon icon="cp-map-marker" fill="#0087af" height="36px" />
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="title font-weight-bold primary--text"
          >Seleccionar ubicación</v-list-item-title
        >
      </v-list-item-content>
    </v-list-item>
    <v-card style="width: 100%; position: relative" class="mb-4 mt-4" flat>
      <LMap
        :zoom="zoom"
        :center.sync="center"
        style="z-index:0; height: 500px"
        v-if="ready"
        class="rounded-custom"
        ref="map"
      ></LMap>

      <div class="marker-static d-flex flex-column align-center justify-center">
        <v-img :src="map_marker"></v-img>
      </div>

      <v-btn
        fab
        absolute
        color="primary"
        bottom
        class="mb-10"
        v-if="canGeolocate"
        right
        small
        @click="getLocation"
        ><v-icon>mdi-crosshairs-gps</v-icon></v-btn
      >
    </v-card>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          label="Localidad"
          v-model="formData.zone"
          outlined
          rounded
          class="mr-2 flex"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="4" md="6" class="d-flex align-center">
        <v-text-field
          label="Latitud"
          v-model="(center || {}).lat"
          text
          class="mr-2"
          rounded
          dense
          disabled
          hide-details
        ></v-text-field>
        <v-text-field
          label="Longitud"
          v-model="(center || {}).lng"
          text
          class="mr-2"
          rounded
          disabled
          dense
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <v-img
      :src="san_pedro"
      height="100"
      width="300"
      contain
      class="d-none d-sm-flex"
      style="position: absolute; bottom: -90px; left: 0; filter: opacity(20%); transform: scaleX(-1); z-index: 999"
    ></v-img>
  </v-card>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import SvgIcon from "@/components/SvgIcon";
export default {
  components: { LMap, LTileLayer, LMarker, SvgIcon },
  props: {
    formData: {
      type: Object,
      required: false,
      default: () => {
        [];
      },
    },
  },
  data: () => ({
    san_pedro: require("@/assets/06_SAN PEDRO JUVENIL (O.insignis).png"),
    map_marker: require("@/assets/cp-map-marker.png"),
    zoom: 4,
    ready: false,
    center: { lat: -32.959556, lng: -71.326253 },
    url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
  }),
  computed: {
    canGeolocate() {
      return !!navigator.geolocation;
    },
  },
  methods: {
    async getLocation() {
      try {
        if (!navigator.geolocation) {
          throw new Error("Geolocalización no disponible");
        }
        let positionSuccess = await new Promise((res, rej) =>
          navigator.geolocation.getCurrentPosition(res, rej)
        );
        let { latitude, longitude } = positionSuccess.coords;

        this.$refs.map.mapObject.setView(
          {
            lat: latitude,
            lng: longitude,
          },
          14
        );
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.ready = true;

    this.$nextTick(() => {
      L.tileLayer
        .bing({
          bingMapsKey:
            "AqZzddAfYuAhbM8Ez9sYiA81Of7Y9xM2idIEFhDH7nc_897g4AMq4TpnKvdmP0To",
          imagerySet: "AerialWithLabels",
        })
        .addTo(this.$refs.map.mapObject);
    });
  },
  watch: {
    center() {
      this.formData.coordinates = [this.center.lng, this.center.lat];
    },
    formData: {
      deep: true,
      handler: function(value) {
        if (value.coordinates) {
          let [lng, lat] = value.coordinates || [];
          if (this.center.lat !== lat || this.center.lng !== lng) {
            this.$refs.map.mapObject.setView({ lat, lng }, 14);
          }
          this.$emit("update:formData", value);
        }
      },
    },
  },
};
</script>

<style>
.marker-static {
  position: absolute;
  height: 45px;
  width: 45px;
  top: calc(50% - 51px);
  left: calc(50% - 22px);
  border-radius: 50% !important;
  z-index: 1;
  pointer-events: none;
}
</style>
